import { AxiosInstance } from './auth/AxiosInstance';

// Create a PayPal payment — server derives the amount from the gig pricing plan
export const createPayment = ({ gigId, pricingPackage, provider = 'paypal' }) =>
  AxiosInstance.post('/payments/create', { gigId, pricingPackage, provider }).then(r => r.data);

// Execute PayPal payment after user approves on PayPal
export const executePayment = ({ paymentId, PayerID, gigId, pricingPackage, provider = 'paypal' }) =>
  AxiosInstance.post('/payments/execute', { paymentId, PayerID, gigId, pricingPackage, provider }).then(r => r.data);

// Create an additional payment for an order
export const createAdditionalPayment = ({ orderId, paymentIndex, provider = 'paypal' }) =>
  AxiosInstance.post('/payments/create-additional', { orderId, paymentIndex, provider }).then(r => r.data);

// Execute an additional payment for an order
export const executeAdditionalPayment = ({ paymentId, PayerID, orderId, paymentIndex, provider = 'paypal' }) =>
  AxiosInstance.post('/payments/execute-additional', { paymentId, PayerID, orderId, paymentIndex, provider }).then(r => r.data);
